module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1JPCT"))).then(() => parcelRequire('iDabs'));